import * as Utils from "./utils";

export function init() {
    htmx.on("htmx:afterSwap", function (event) {
        if (event.target.id === "appeal-banners") {
            buildBanners();

            // Run any watch transitions
            if (document.querySelector(".js-watch")) {
                Utils.animateInViewEls(".js-watch", "in-view", 0.06);
            }

            if (document.querySelector(".js-watch--opacity")) {
                Utils.animateInViewEls(".js-watch--opacity", "in-view", 0.06);
            }
        }
    });
}

function buildBanners() {
    const messages = [...document.querySelectorAll(".js-appeal-banner")];

    if (messages.length) {
        Utils.slideDown(messages[0], 500);

        // When a close link is clicked:
        // – Hide the message
        // – Create a cookie for that message using messageid data attr
        // – show the next message if there is one
        document.querySelectorAll(".js-appeal-banner-close").forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();

                var d = new Date();

                // Hide this message
                Utils.slideUp(el.closest(".js-appeal-banner"), 500);
                // el.closest('.js-appeal-banner').classList.add('!hidden');

                // Create a cookie for this announcement to expire 2 weeks from now
                d.setTime(d.getTime() + 14 * 24 * 60 * 60 * 1000);

                document.cookie =
                    el.dataset.messageid +
                    "=true; expires=" +
                    d.toUTCString() +
                    "; path=/";

                // Show the next announcement if there is one
                messages.shift();

                if (messages.length) {
                    setTimeout(() => {
                        Utils.slideDown(messages[0], 500);
                    }, 750);
                }
            });
        });
    }
}
